import { CFlexContainer } from "../CFlexContainer";
import { Tag } from "../../Tag";
import { Page } from "../../Page";
import { WindowHead } from "./Head";
import { toMap, getAppService, getWebPageService } from "../../../../../HA";

export class Window extends CFlexContainer {
    protected initialize(data: any) {
        super.initialize(data);
        this.addClass("w");
        this.initController();
    }

    protected initController() {
        const wca = this.translate("#wca");
        if (wca) {
            this.addToData("wcancel", () => {
                getAppService().processAction(toMap(wca));
            });
        }

        const waa = this.translate("#waa");
        if (waa) {
            this.addToData("waccept", () => {
                getAppService().processAction(toMap(waa));
            });
        }

        if (!this.get("wcancel") || !(this.get("wcancel") instanceof Function)) {
            this.addToData("wcancel", () => {
                getWebPageService().removeCurrentApp();
            });
        }
        this.createControlPanel();
    }

    protected createControlPanel() {
        let t = this.get("title");
        if (!t && this.hasTrans("#wt")) {
            t = this.translate("#wt");
        }
        const cp = new WindowHead(toMap({
            accept: this.get("waccept"),
            cancel: this.get("wcancel"),
            title: t,
        }));
        this.addToData("controlPanel", cp);
        this.insertOnTop(cp);
    }

    protected createByType(data: Map<any, any>, main: Tag) {
        Page.createNewByType(data, main);
    }
}
